import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Header from "./common/Header";
import Footer from "./common/Footer";
import MenuPic from "./MenuPic";
import SEO from "./SEO";
import ReviewCards from "./menu/ReviewCards";
import MenuCategorySelector from "./menu/MenuCategorySelector";

import appController from "./Controllers";
import { foodCategories, getCategoryName } from "./menu/menuData";
import { setContent } from "./menu/menuContentRenderer";

const Menu = () => {
  const { locationId, templateId } = useParams();
  const [foodId, setFoodId] = useState(null);

  const handleCategorySelect = (id) => {
    setFoodId(id);
  };

  const resetCounter = (reset) => {
    setFoodId(reset);
  };

  const renderNavigation = () => {
    return getCategoryName(foodId, templateId);
  };

  useEffect(() => {
    if (window.AOS) window.AOS.init();
  }, []);

  const locationName = locationId === "Rio-Linda" ? "Rio Linda" : "Rancho Cordova";
  const menuTitle = `Menu - ${locationName} Location | Bowinkles Drive Thru`;

  return (
    <>
      <SEO
        title={menuTitle}
        description={`View the complete menu at Bowinkles Drive Thru ${locationName} location. Order burgers, sandwiches, Mexican food, wings, nuggets, salads, desserts, and more.`}
        keywords={`Bowinkles menu ${locationName}, fast food menu, burgers, wings, Mexican food, ${locationName} restaurant menu, Bowinkles prices`}
        image="/images/bowinklesfoodcover.jpeg"
      />
      <div className="container-fluid">
        <Header />
        <ReviewCards />

        <MenuPic storeId={templateId} />

        <div className="menuContainer">
          <div className="container">
            <h1 className="text-center">
              {"Menu " + appController.titleChange(locationId)}
            </h1>
            <h2 onClick={() => resetCounter(null)}>
              {foodId === null ? (
                <p className="breadcrumb" style={{ cursor: "pointer" }}>
                  Menu
                </p>
              ) : (
                <p className="breadcrumb" style={{ cursor: "pointer" }}>
                  Menu / {renderNavigation()}
                </p>
              )}
            </h2>
            <div className="row justify-content-center">
              <MenuCategorySelector
                foodInfo={foodCategories}
                templateId={templateId}
                foodId={foodId}
                onSelectCategory={handleCategorySelect}
              />
            </div>
            <div className="foodContainer">
              {setContent(foodId, templateId)}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Menu;
